/**
 * @generated SignedSource<<dbdfa206036317c5136e3ead7e9e25a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutProgressReview_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryReview_item">;
  readonly " $fragmentType": "CheckoutProgressReview_item";
};
export type CheckoutProgressReview_item$key = {
  readonly " $data"?: CheckoutProgressReview_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutProgressReview_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutProgressReview_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryReview_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "3f2552db74d446327a61145adaa0e661";

export default node;
